"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var g = {
    device: 'roadshow_web'
};
var IMClientSDK = require('./IMClientWechat.js');
var util_1 = require("./util");
var cookie_1 = __importDefault(require("../cookie"));
var user_1 = __importDefault(require("../user"));
var moment_1 = __importDefault(require("moment"));
var lazyFun = (0, util_1.lazyload)(1000);
var channel_id = urlid;
var thisuid = '';
if (user_1.default.get() != null) {
    thisuid = (_a = user_1.default.get()) === null || _a === void 0 ? void 0 : _a.id;
}
var enumMemberSetting = {
    禁言: 10124010,
    解除禁言: 10124011,
    用户改名申请: 10124013,
    踢出直播间: 10124014,
    通知文档跳转: 10127014,
    主播离开直播间: 10121030,
    通知文档演示结束: 10127015,
    主播通知路演继续: 10121020,
    用户通知路演继续: 10126022,
    连麦状态变更: 10126023,
    用户进入直播间: 10124016,
    用户退出直播间: 10124017,
    发消息: 10111001,
    发图片消息: 10111003,
    收到私信: 10112001,
    发引用消息: 10111002,
    多端登录: 10124200,
    直播开始了: 10121010,
    直播结束了: 10121999,
    请求举手: 10126010,
    取消举手: 10126011,
    允许上麦: 10126012,
    拒绝上麦: 10126013,
    操作下麦: 10126014,
    用户下麦: 10126015,
    连麦成功: 10126016,
    批量拒绝所有举手申请: 10126017,
    设置禁止举手: 10126020,
    新增公告: 10128000,
    删除公告: 10128001,
    修改公告: 10128002,
    直播间删除: 10121998,
    预告地址变更: 10121400,
    通知直播地址变更: 10121500,
    直播测试结束: 1012100130,
    通知直播测试地址变更: 1012100110
};
var IMClient = null;
var this_IMUserID;
var getNewMessage = function (newmessage) {
    console.info(newmessage);
};
var onForbidden = function () {
    console.info('被禁言');
};
var onCancelForbidden = function () {
    console.info('被解除禁言');
};
var onAllForbidden = function () {
    console.info('全员被禁言');
};
var onAllCancelForbidden = function () {
    console.info('全员被解除禁言');
};
var onDocumentShow = function (data) {
    console.info('文档跳转');
};
var onDocumentEnd = function () {
    console.info('展示文档结束');
};
var onShowStart = function (data) {
    console.info('直播开始了');
};
var onShowEnd = function (data) {
    console.info('直播结束了');
};
var onPresentersLeft = function (res) {
    console.info('主播离开直播间');
};
var onPresentersContinue = function (res) {
    console.info('主播通知路演继续');
};
var onKickOut = function () {
    console.info('被提出直播间');
};
var onNotice = function (txt) {
    console.info('发公告');
};
var onDeleteRome = function () {
    console.info('直播间删除');
};
var onChangeForeshow = function (data) {
    console.info('预告地址变更');
};
var onChangeLiveshow = function (data) {
    console.info('直播地址变更');
};
var onChannelMessagesForPriParams = {};
var onChannelMessagesForPri = function (data) {
    console.log("获取历史");
};
var onShowTestEnd = function (data) {
    console.info('直播测试结束了');
};
var onChangeLiveTestshow = function (data) {
    console.info('直播测试地址变更');
};
function init() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            IMClient = new IMClientSDK({
                debug: false
            });
            //websocket登录成功以后，登录直播间
            IMClient.on('connected', function () {
                login();
            });
            IMClient.on('allMessages', function (res, protocol) {
                // console.info('%cprotocol:' + protocol ,'color:green;') 
                // console.info('%cprotocol:' + protocol + ' res:' + JSON.stringify(res),'color:red;')  
                var _a;
                if (protocol == 253) { //登录反馈
                    if (!res.ResultCode) { //没有ResultCode或者0 表示成功
                        console.info('im登录成功');
                        IMClient.joinChannel(channel_id, 0);
                    }
                }
                else if (protocol == 224) { //订阅频道的反馈（224）            
                    if (!res.ResultCode) { //没有ResultCode或者0 表示成功
                        console.info('进入房间成功');
                        //that.DATA.userCanPostMessage = true //订阅频道成功 用户可以发送消息                     
                    }
                    else {
                        console.log("进入房间失败" + JSON.stringify(res));
                    }
                    getMessageList();
                    // 根据条件获取历史
                    getChannelMessagesForPriList(onChannelMessagesForPriParams);
                }
                else if (protocol == 96) {
                    if (!res.ResultCode) {
                        if ((res === null || res === void 0 ? void 0 : res.ChannelID) == channel_id && (res === null || res === void 0 ? void 0 : res.UserID) == this_IMUserID) {
                            if (res.Status == 1) {
                                onForbidden();
                            }
                            else if (res.Status == 2) {
                                onCancelForbidden();
                            }
                        }
                        if ((res === null || res === void 0 ? void 0 : res.ChannelID) == channel_id && res.UserID == "") {
                            if (res.Status == 1) {
                                onAllForbidden();
                            }
                            else if (res.Status == 2) {
                                onAllCancelForbidden();
                            }
                        }
                        // if (res?.ChannelID == channel_id && res?.UserID == this_IMUserID) {
                        //     onForbidden()
                        // }
                    }
                }
                else if (protocol == 179) {
                    var notify_type = res === null || res === void 0 ? void 0 : res.ContentType;
                    if (!notify_type) { //没有消息类型
                        return;
                    }
                    if ((res === null || res === void 0 ? void 0 : res.ChannelID) != channel_id) {
                        console.error('不是当前的房间号');
                        return;
                    }
                    console.info(111);
                    if (notify_type == enumMemberSetting.发引用消息) {
                        console.info(222);
                        getNewMessage(res);
                    }
                }
                else if (protocol == 174) { //收到最新的频道消息从
                    var content = JSON.parse((res === null || res === void 0 ? void 0 : res.Content) || {});
                    var notify_type = res === null || res === void 0 ? void 0 : res.ContentType;
                    if (!notify_type) { //没有消息类型
                        return;
                    }
                    if ((res === null || res === void 0 ? void 0 : res.ChannelID) != channel_id) {
                        console.error('不是当前的房间号');
                        return;
                    }
                    if (notify_type === enumMemberSetting.新增公告 || notify_type === enumMemberSetting.修改公告) {
                        var ggtext = JSON.parse(res.Content).message.content;
                        onNotice(ggtext);
                    }
                    //通知直播开始
                    if (notify_type === enumMemberSetting.直播开始了) {
                        var message = JSON.parse(res.Content).message || {};
                        onShowStart(message);
                    }
                    else if (notify_type === enumMemberSetting.直播结束了) {
                        var message = JSON.parse(res.Content).message || {};
                        onShowEnd(message);
                    }
                    // // 用户禁言
                    // else if (notify_type == enumMemberSetting.禁言) {
                    //     // console.info(this_IMUserID)
                    //     let toUserID = content?.to_user?.emuid
                    //     if (toUserID && toUserID == thisuid) {
                    //         onForbidden()
                    //     }
                    // }
                    // // 解除禁言
                    // else if (notify_type == enumMemberSetting.解除禁言) {
                    //     // console.info(this_IMUserID)
                    //     let toUserID = content?.to_user?.emuid
                    //     if (toUserID && toUserID == thisuid) {
                    //         onCancelForbidden()
                    //     }
                    // }
                    else if (notify_type == enumMemberSetting.用户改名申请) {
                    }
                    //踢出直播间 
                    else if (notify_type == enumMemberSetting.踢出直播间) {
                        var toUserID = (_a = content === null || content === void 0 ? void 0 : content.to_user) === null || _a === void 0 ? void 0 : _a.emuid;
                        if (toUserID && toUserID == thisuid) {
                            onKickOut();
                        }
                    }
                    // 文档演示
                    else if (notify_type == enumMemberSetting.通知文档跳转) {
                        onDocumentShow(res);
                    }
                    else if (notify_type == enumMemberSetting.通知文档演示结束) {
                        onDocumentEnd();
                    }
                    //更新成员列表
                    else if (notify_type == enumMemberSetting.用户进入直播间) {
                    }
                    else if (notify_type == enumMemberSetting.用户退出直播间) {
                    }
                    else if (notify_type == enumMemberSetting.发消息) {
                        getNewMessage(res);
                    }
                    else if (notify_type == enumMemberSetting.收到私信) {
                        getNewMessage(res);
                    }
                    else if (notify_type == enumMemberSetting.发引用消息) {
                        getNewMessage(res);
                    }
                    else if (notify_type == enumMemberSetting.发图片消息) {
                    }
                    else if (notify_type == enumMemberSetting.主播通知路演继续) {
                        onPresentersContinue(res);
                    }
                    else if (notify_type == enumMemberSetting.用户通知路演继续) {
                    }
                    else if (notify_type == enumMemberSetting.主播离开直播间) {
                        onPresentersLeft(res);
                    }
                    else if (notify_type == enumMemberSetting.直播间删除) {
                        onDeleteRome();
                    }
                    else if (notify_type == enumMemberSetting.预告地址变更) {
                        var message = JSON.parse(res.Content).message;
                        onChangeForeshow(message);
                    }
                    else if (notify_type == enumMemberSetting.通知直播地址变更) {
                        var message = JSON.parse(res.Content).message;
                        onChangeLiveshow(message);
                    }
                    else if (notify_type == enumMemberSetting.直播测试结束) {
                        var message = JSON.parse(res.Content).message || {};
                        onShowTestEnd(message);
                    }
                    else if (notify_type == enumMemberSetting.通知直播测试地址变更) {
                        var message = JSON.parse(res.Content).message || {};
                        onChangeLiveTestshow(message);
                    }
                }
            });
            return [2 /*return*/];
        });
    });
}
init();
function login() {
    if (cookie_1.default.get('ct') && cookie_1.default.get('ut')) {
        IMClient.authUser({
            ct: cookie_1.default.get('ct'),
            ut: cookie_1.default.get('ut'),
            source: 2,
            device: g.device,
            version: 1,
            success: function (res) {
                var _a;
                console.info('获取token成功');
                var _b = (res === null || res === void 0 ? void 0 : res.data) || {}, IMUserID = _b.IMUserID, RefreshToken = _b.RefreshToken, Token = _b.Token;
                if (IMUserID && RefreshToken && Token) {
                    this_IMUserID = IMUserID;
                    IMClient.loginByIMToken(IMUserID, Token, g.device, 1, RefreshToken);
                }
                else {
                    console.info('IMUserID:为空');
                }
                ;
                self.CertifiedType = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.CertifiedType;
            },
            fail: function (e) {
                console.info('失败了！', e);
            }
        });
    }
    else {
        IMClient.anonymousUser({
            NickName: '未登录用户' + Math.floor(Math.random() * 10000 + 1),
            Version: '0',
            IMUserID: '',
            Device: g.device,
            version: 1,
            success: function (res) {
                console.info('获取token成功');
                var _a = (res === null || res === void 0 ? void 0 : res.data) || {}, IMUserID = _a.IMUserID, RefreshToken = _a.RefreshToken, Token = _a.Token;
                if (IMUserID && RefreshToken && Token) {
                    this_IMUserID = IMUserID;
                    IMClient.loginByIMToken(IMUserID, Token, g.device, 1, RefreshToken);
                }
                else {
                    console.info('IMUserID:为空');
                }
            },
            fail: function (e) {
                console.info('失败了！', e);
            }
        });
    }
}
var getListCallback = function (data) {
    // console.info(data)
};
var getHistoryListCallback = function (data) {
    // console.info(data)
};
/**
 * 每页多少条
 */
var pageSize = 100;
/**
 * 最多多少页
 */
var maxPage = 5;
function getMessageByPage(maxindex) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resovle, reject) {
                    IMClient.getMessageOrderListByIndex({
                        channelID: channel_id,
                        index: maxindex,
                        descOrder: true,
                        pageSize: pageSize,
                        success: function (backdata) {
                            //console.info(data)
                            //data.data = data.data.reverse()
                            var nowmaxindex = 0;
                            var returndata = [];
                            //if(backdata.result == 1 && backdata.data && backdata.data.length > 0){
                            try {
                                nowmaxindex = JSON.parse(backdata.data[backdata.data.length - 1].Content).MsgIndexID - 1;
                            }
                            catch (error) {
                            }
                            try {
                                returndata = backdata.data;
                            }
                            catch (error) {
                            }
                            //}
                            resovle({
                                data: returndata,
                                maxindex: nowmaxindex
                            });
                            // getListCallback(data)
                        }
                    });
                })];
        });
    });
}
function getMessageListAll(maxindex) {
    var _a, e_1, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var maxindexnow, numberarray, messagedataall, index, _d, numberarray_1, numberarray_1_1, nowindex, backdata, e_1_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    maxindexnow = maxindex;
                    numberarray = [];
                    messagedataall = [];
                    for (index = 0; index < maxPage; index++) {
                        numberarray.push(index + 1);
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 7, 8, 13]);
                    _d = true, numberarray_1 = __asyncValues(numberarray);
                    _e.label = 2;
                case 2: return [4 /*yield*/, numberarray_1.next()];
                case 3:
                    if (!(numberarray_1_1 = _e.sent(), _a = numberarray_1_1.done, !_a)) return [3 /*break*/, 6];
                    _c = numberarray_1_1.value;
                    _d = false;
                    nowindex = _c;
                    return [4 /*yield*/, getMessageByPage(maxindexnow)];
                case 4:
                    backdata = _e.sent();
                    messagedataall = messagedataall.concat(backdata.data);
                    if (backdata.data.length == 0 || maxindex == 0) {
                        return [3 /*break*/, 6];
                    }
                    maxindexnow = backdata.maxindex;
                    _e.label = 5;
                case 5:
                    _d = true;
                    return [3 /*break*/, 2];
                case 6: return [3 /*break*/, 13];
                case 7:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 13];
                case 8:
                    _e.trys.push([8, , 11, 12]);
                    if (!(!_d && !_a && (_b = numberarray_1.return))) return [3 /*break*/, 10];
                    return [4 /*yield*/, _b.call(numberarray_1)];
                case 9:
                    _e.sent();
                    _e.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 12: return [7 /*endfinally*/];
                case 13: 
                // console.info(messagedataall)
                return [2 /*return*/, messagedataall.reverse()];
            }
        });
    });
}
/**
 * 获取聊天记录
 */
function getMessageList() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            IMClient.getMaxIndex({
                channelID: channel_id,
                success: function (maxdata) {
                    var maxindex = maxdata.data;
                    setTimeout(function () {
                        // 
                        // IMClient.getMessageOrderListByIndex({
                        //     channelID: channel_id,
                        //     index: maxindex,
                        //     descOrder: true,
                        //     pageSize: 100,
                        //     success: function (data: any) {
                        //         //console.info(data)
                        //         data.data = data.data.reverse()
                        //         getListCallback(data)
                        //     }
                        // })    
                        getMessageListAll(maxindex).then(function (backdata) {
                            getListCallback(backdata);
                        });
                    }, 1500);
                },
                fail: function (back) {
                    getListCallback(null);
                    console.info('获取message最大index失败');
                }
            });
            return [2 /*return*/];
        });
    });
}
/**
 * 根据条件查询历史记录
 *
 */
function getChannelMessagesForPriList(paramsobj) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            IMClient.getChannelMessagesForPri({
                params: {
                    channelID: channel_id,
                    pageIndex: paramsobj.pageIndex || 1,
                    pageSize: paramsobj.pageSize || 20,
                    orderby: 1,
                    beginTime: "2010-01-01",
                    endTime: (0, moment_1.default)().format("YYYY-MM-DD")
                },
                success: function (res) {
                    setTimeout(function () {
                        var data = JSON.parse(res === null || res === void 0 ? void 0 : res.data);
                        onChannelMessagesForPri(data === null || data === void 0 ? void 0 : data.data);
                    }, 1500);
                },
                fail: function (back) {
                    console.info('获取历史chat失败');
                }
            });
            return [2 /*return*/];
        });
    });
}
exports.default = {
    getList: function (callback) {
        getListCallback = callback;
    },
    //  根据条件获取历史记录
    getHistoryListForPri: function (params, callback) {
        onChannelMessagesForPriParams = params;
        onChannelMessagesForPri = callback;
    },
    regGetNewMessage: function (callback) {
        getNewMessage = callback;
    },
    /**
     * 被禁言
     * @param callback
     */
    onForbidden: function (callback) {
        onForbidden = callback;
    },
    /**
     * 被解除禁言
     * @param callback
     */
    onCancelForbidden: function (callback) {
        onCancelForbidden = callback;
    },
    /**
     * 全员被禁言
     * @param callback
     */
    onAllForbidden: function (callback) {
        onAllForbidden = callback;
    },
    /**
     * 全员被解除禁言
     * @param callback
     */
    onAllCancelForbidden: function (callback) {
        onAllCancelForbidden = callback;
    },
    sendNewMessage: function (newmessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        IMClient.sendToChannel({
                            channelID: channel_id,
                            contentType: enumMemberSetting.发消息,
                            persist: true,
                            content: JSON.stringify({
                                txt: newmessage,
                                ua: "web;lk.web"
                            }),
                            seq: (new Date()).getTime(),
                            success: function () {
                                resolve();
                            },
                            fail: function (message) {
                                reject(new Error(message));
                            }
                        });
                    })];
            });
        });
    },
    sendNewQuoteMessage: function (newmessage, quotemessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // console.info(quotemessage)
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        IMClient.sendChannelQuoteMessage({
                            channelID: channel_id,
                            contentType: enumMemberSetting.发引用消息,
                            persist: true,
                            content: JSON.stringify({
                                txt: newmessage,
                                ua: "web;lk.web"
                            }),
                            seq: (new Date()).getTime(),
                            quoteMessage: quotemessage,
                            success: function () {
                                resolve();
                            },
                            fail: function (message) {
                                reject(new Error(message));
                            }
                        });
                    })];
            });
        });
    },
    regDocumentShow: function (callback) {
        onDocumentShow = callback;
    },
    regDocumentEnd: function (callback) {
        onDocumentEnd = callback;
    },
    /**
     * 直播开始
     * @param callback
     */
    onShowStart: function (callback) {
        onShowStart = callback;
    },
    /**
     * 直播结束
     * @param callback
     */
    onShowEnd: function (callback) {
        onShowEnd = callback;
    },
    /**
     * 主播离开直播间
     * @param callback
     */
    onPresentersLeft: function (callback) {
        onPresentersLeft = callback;
    },
    /**
     * 主播通知路演继续
     * @param callback
     */
    onPresentersContinue: function (callback) {
        onPresentersContinue = callback;
    },
    /**
     * 被提出直播间
     */
    onKickOut: function (callback) {
        onKickOut = callback;
    },
    onNotice: function (callback) {
        onNotice = callback;
    },
    /**
     * 删除直播间
     * @param callback
     */
    onDeleteRome: function (callback) {
        onDeleteRome = callback;
    },
    /**
     * 预告地址变更
     * @param callback
     */
    onChangeForeshow: function (callback) {
        onChangeForeshow = callback;
    },
    /**
     * 直播地址变更
     * @param callback
     */
    onChangeLiveshow: function (callback) {
        onChangeLiveshow = callback;
    },
    /**
     * 直播测试结束
     * @param callback
    */
    onShowTestEnd: function (callback) {
        onShowTestEnd = callback;
    },
    /**
   * 直播测试地址变更
   * @param callback
   */
    onChangeLiveTestshow: function (callback) {
        onChangeLiveTestshow = callback;
    }
};
//# sourceMappingURL=data:application/json;base64,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